import React from "react";
import { Layout, Space } from "antd";
import TopbarWrapper from "./Topbar.style";
import TopbarUser from "./TopbarUser";
import TenantsTopBarUser from "./TenantsTopBarUser";
import LanguageSwitcher from "./LanguageSwitcher";
import BranchSelector from "./BranchSelector";
import Logo from "./Logo";
import ToDoList from "../crm/components/toDoList";
import { useSelector } from "react-redux";
import { usePermission } from "../../hooks/accessControl";
import { useParams } from "react-router-dom";

const { Header } = Layout;
const DashboardHeader = () => {
  let { branchId } = useParams();
  const organizationDetails = useSelector(
    (state) => state.organization.details
  );
  const allowedFeatures =
    organizationDetails.features &&
    organizationDetails.features.map((i) => i.name);
  const crmIsAllowed = allowedFeatures?.includes("crm");
  const hasCrmViewerPermission = usePermission(branchId, "crm", "viewer");
  const direction = useSelector(
    (state) => state.user.currentAppLocale.direction
  );

  return (
    <TopbarWrapper>
      <Header className="header">
        <div className="left">
          <Space size={40} style={{ alignItems: "end" }}>
            <Logo />
            {crmIsAllowed && hasCrmViewerPermission && <ToDoList />}
          </Space>
        </div>
        <ul className="right">
          <li>
            <BranchSelector />
          </li>
          <li>
            {process.env.REACT_APP_BUILD_TARGET === "tenants" ? (
              <TenantsTopBarUser direction={direction} />
            ) : (
              <TopbarUser direction={direction} />
            )}
          </li>
          <li>
            <LanguageSwitcher />
          </li>
        </ul>
      </Header>
    </TopbarWrapper>
  );
};

export default DashboardHeader;
